<template>
  <div class="vue-video-player" v-if="src">
    <vue-video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      @play="$emit('play', $event)"
      @ended="$emit('ended', $event)"
      @loadedmetadata="$emit('loadedmetadata', $event)"
      @canplay="$emit('canplay', $event)"
      @waiting="$emit('waiting', $event)"
    ></vue-video-player>
    <div class="video-mask" @click="playVideo" v-if="!playing"></div>
    <img class="play-icon" src="@/static/images/contentManage/05.png" v-if="!playing" @click="playVideo"/>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'; // 视频播放器
export default {
  components: {
    vueVideoPlayer: videoPlayer
  },
  props: {
    src: {
      type: String
    },
    cover_url: {
      type: String
    }
  },
  watch:{
    src: {
      handler(){
        this.playing = false;
        this.playerOptions = {
          // playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
          // controls: true,
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              src: this.src // 路径
              // type: 'application/x-mpegURL'
              // type: "video/mp4", // 类型
            }
          ],
          // bigPlayButton 默认去掉了播放按钮
          children: [
            'mediaLoader',
            'posterImage',
            'textTrackDisplay',
            'loadingSpinner',
            'liveTracker',
            'controlBar',
            'errorDisplay',
            'textTrackSettings',
            'resizeManager'
          ],
          poster: this.cover_url, // 你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            currentTimeDisplay: true,
            pictureInPictureToggle: false, // 画中画
            audioTrackButton: false, // 音频菜单
            subsCapsButton: false, // 语言菜单
            timeDivider: false, //当前时间和持续时间的分隔符
            durationDisplay: false, //显示持续时间
            remainingTimeDisplay: true, //是否显示剩余时间功能
            fullscreenToggle: true //全屏按钮
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  data() {
    return {
      playing: false,
      // 配置信息
      playerOptions: {
        
      }
    };
  },
  methods: {
    playVideo(){
      this.player.pause();
      this.player.play();
      this.playing = true;
    },
  }
};
</script>
<style lang="scss" scoped>
.vue-video-player {
  .play-icon {
    position: absolute;
    cursor: pointer;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  /deep/ .video-js .vjs-current-time {
    display: block;
  }
}
</style>
